import { render, staticRenderFns } from "./video.vue?vue&type=template&id=3a427a60"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a427a60')) {
      api.createRecord('3a427a60', component.options)
    } else {
      api.reload('3a427a60', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=3a427a60", function () {
      api.rerender('3a427a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/types/video.vue"
export default component.exports